var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('div',{staticClass:"left-panel"},[_c('MainLeftPanel')],1),_c('el-scrollbar',{staticClass:"scroll-bar main-panel"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }